const separator = ' ';

// Make sure strings are not too long
export const splitString = (str: string, maxLength: number) => {
	const words = str.split(separator);

	return words.reduce((lines, word) => {
		const lastLine = lines[lines.length - 1] || '';
		const appendedLastLine = lastLine === '' ? word : `${lastLine} ${word}`;

		if (appendedLastLine.length <= maxLength) {
			return [...lines.slice(0, -1), appendedLastLine];
		}

		return [...lines, word];
	}, [] as Array<string>);
};
